import { HStack, Pressable } from 'native-base'
import { useCallback } from 'react'

import { ThumbsDown, ThumbsUp } from '@phosphor-icons/react'

import { colors } from '../../utils/theme/configureTheme'

interface ThumbsRatingProps {
  value: boolean | null
  onChange: (value: boolean) => void
}

/** Thumbs up/down toggle for boolean satisfaction ratings. */
export default function ThumbsRating({ value, onChange }: ThumbsRatingProps) {
  const handleThumbsDown = useCallback(() => onChange(false), [onChange])
  const handleThumbsUp = useCallback(() => onChange(true), [onChange])

  const getIconColor = (isPositive: boolean) => {
    if (value === null) return '#5D5D5A'
    if (value === isPositive) return isPositive ? '#22562E' : '#E84931'
    return colors.gray[100]
  }

  const getBackgroundColor = (isPositive: boolean) => {
    if (value === null) return 'transparent'
    if (value === isPositive) return isPositive ? '#D4F3D9' : '#F5E7E7'
    return 'transparent'
  }

  return (
    <HStack space={4} justifyContent="center" alignItems="center" my={2}>
      <Pressable onPress={handleThumbsDown} p={3} borderRadius={12} backgroundColor={getBackgroundColor(false)}>
        <ThumbsDown size={28} weight={value === false ? 'fill' : 'regular'} color={getIconColor(false)} />
      </Pressable>
      <Pressable onPress={handleThumbsUp} p={3} borderRadius={12} backgroundColor={getBackgroundColor(true)}>
        <ThumbsUp size={28} weight={value === true ? 'fill' : 'regular'} color={getIconColor(true)} />
      </Pressable>
    </HStack>
  )
}
